import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { FormSimpleMoneyInput } from "shared/components/input/text/SimpleMoneyInput";

export const PaydownTotalAmountInput: React.FC<{
  rowIndex: string;
  inputName: string;
}> = ({ rowIndex, inputName }) => {
  const { control } = useFormContext();
  const isProrata = useWatch({
    control,
    name: `uses.${rowIndex}.is_prorata`,
  });
  const isDisabled = !isProrata;
  return (
    <FormSimpleMoneyInput
      name={inputName}
      isDisabled={isDisabled}
      shouldUnregister={false}
      placeholder={isDisabled ? undefined : "0.00"}
      variant="simple-table"
      showCurrencyIcon={false}
      showCurrencyPrefix={false}
    />
  );
};

export const PaydownFundAmountInput: React.FC<{
  rowIndex: string;
  inputName: string;
}> = ({ rowIndex, inputName }) => {
  const { control } = useFormContext();
  const isProrata = useWatch({
    control,
    name: `uses.${rowIndex}.is_prorata`,
  });
  return (
    <FormSimpleMoneyInput
      name={inputName}
      isDisabled={isProrata}
      placeholder={isProrata ? undefined : "0.00"}
      shouldUnregister={false}
      variant="simple-table"
      showCurrencyIcon={false}
      showCurrencyPrefix={false}
    />
  );
};
